<template>
  <div class="flex flex-col mt-4 mb-4 mr-2 justify-start bg-white shadow-lg rounded-lg overflow-hidden">
    <div class="flex flex-row section-title h-16">
      <router-link
        :to="{name:'excercisesDetails',params:{key:shortKey}}"
        class="flex-grow"
      >
        <span>{{ title }}</span>
      </router-link>
      <i
        class="far fa-trash-alt cursor-pointer mr-2"
        @click="onRemove()"
      />
      <div
        v-if="difficulty && difficulty>0"
        class="flex flex-row text-grey-darker mb-1 items-center text-sm h"
      >
        <div class="font-bold w-24">
          Schwierigkeit:
        </div>
        <div
          class="flex flex-row ml-2"
          :class="colorDifficulty(difficulty)"
        >
          <div
            v-for="i in difficulty"
            :key="i"
          >
            <i
              style="margin: 0.125rem"
              class="text-xs fas fa-square"
            />
          </div>
          <div
            v-for="i in emptyDifficultSquares(difficulty)"
            :key="i"
          >
            <i
              style="margin: 0.125rem"
              class="text-xs far fa-square text-gray-400"
            />
          </div>
          <div class="ml-2">
            {{ textDifficulty(difficulty) }}
          </div>
        </div>
      </div>

      <div
        v-if="intensity && intensity>0"
        class="flex flex-row text-grey-darker mb-1 items-center text-sm h"
      >
        <div class="font-bold w-24">
          Intensität:
        </div>
        <div
          class="flex flex-row ml-2"
          :class="colorIntensity(intensity)"
        >
          <div
            v-for="i in intensity"
            :key="i"
          >
            <i class="text-xs fas fa-star" />
          </div>
        </div>
        <div
          v-for="i in emptyIntensitySquares(intensity)"
          :key="i"
        >
          <i
            style="margin: 0.125rem"
            class="text-xs far fa-star text-gray-400"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <router-link
        :to="{name:'excercisesDetails',params:{key:shortKey}}"
        class="flex-grow"
      >
        <img
          class="w-72 h-32 object-cover"
          :src="image"
        >
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ExerciseMedium',
    props: {
        title: {
            type: String,
            required: false
        },
        image: {
            type: String,
            required: false
        },
        shortKey: {
            type: String,
            required: false
        },
        intensity: {
            type: Number,
            required: false
        },
        difficulty: {
            type: Number,
            required: false
        },
        tags: {
            type: Object,
            required: false
        }
    },
    methods: {
        textDifficulty (difficulty) {
            if (difficulty && difficulty > 0) {
                if (difficulty === 1) {
                    return 'Anfänger'
                } else if (difficulty === 2) {
                    return 'Leicht'
                } else if (difficulty === 3) {
                    return 'Mittel'
                } else if (difficulty === 4) {
                    return 'Schwer'
                }
            } else {
                return ''
            }
        },
        colorDifficulty (difficulty) {
            if (difficulty && difficulty > 0) {
                if (difficulty < 3) {
                    return 'text-green-600'
                } else if (difficulty === 3) {
                    return 'text-yellow-600'
                } else if (difficulty === 4) {
                    return 'text-red-600'
                } else {
                    return ''
                }
            }
        },
        colorIntensity (intensity) {
            if (intensity && intensity > 0) {
                if (intensity < 3) {
                    return 'text-green-600'
                } else if (intensity === 3) {
                    return 'text-yellow-600'
                } else if (intensity === 4) {
                    return 'text-orange-600'
                } else if (intensity >= 5) {
                    return 'text-red-600'
                }
            } else {
                return ''
            }
        }
    },
    emptyDifficultSquares (difficulty) {
        return 4 - difficulty
    },
    emptyIntensitySquares (intensity) {
        return 5 - intensity
    },
    onRemove () {
        this.$emit('removed', this.shortKey)
    }
}
</script>

<style scoped>

</style>